export default {"src":"/_next/static/media/SOND.cc3f8708.svg","height":18,"width":18};